<template>
  <el-dialog title="详情"
             :visible.sync="detailShow"
             v-dialogDrag>
    <el-row style="margin-bottom:10px">
      <el-col :span="6">
        <label>任务名称：</label>
        <span class="info-value ell" :title="detailInfo.taskName">{{detailInfo.taskName}}</span>
      </el-col>
      <el-col :span="6">
        <label>巡检人员：</label>
        <span class="info-value ell" :title="detailInfo.inspectPersonList">{{detailInfo.inspectPersonList}}</span>
      </el-col>
      <el-col :span="6">
        <label>状态：</label>
        <span class="info-value">{{status[detailInfo.status]}}</span>
      </el-col>
    </el-row>
    <div class="detail_list">
      <h4>巡检设备</h4>
      <ioc-table ref="crud"
                 v-model="detailList"
                 :data="detailData"
                 :option="option"
                 :page="page"
                 @size-change="handleSizeChange"
                 @current-change="handleCurrentChange">
      </ioc-table>
    </div>
  </el-dialog>
</template>

<script>
import { api } from "../api";
import tableOption from '../const/recordDetailOption'
import utils from '@src/common/utils'
export default {
  props: {
  },
  data () {
    return {
      detailInfo: {},
      detailShow: false,
      detailList: {},
      detailData: [],
      option: tableOption(this),
      page: {
        currentPage: 1,
        total: 0,
        pageSize: utils.Cache.get('CURRENT_PAGESIZE') || 10
      },
      status:{
        '1': '待巡检',
        '2': '执行中',
        '3': '已完成',
        '4': '超时'
      }
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    open (detailInfo) {
      this.detailShow = true
      const nameList = []
      console.log('detailInfo', detailInfo)
      if (detailInfo.inspectPersonList && detailInfo.inspectPersonList.length) {
        detailInfo.inspectPersonList.map(item => {
          nameList.push(item.nickName)
        })
      }
      // detailInfo.inspectPersonList = nameList
      this.detailInfo = Object.assign({}, detailInfo);
      this.detailInfo.inspectPersonList = nameList.toString()
      this.getDetailList()
    },
    getDetailList () {
      const params = {
        taskCode: this.detailInfo.taskCode,//任务code
        pageNum: this.page.currentPage,
        pageSize: this.page.pageSize,
      }
      this.$fetch(api.inspectionPlan.queryTaskRecordDetail, params).then(res => {
        if (res && res.success) {
          this.detailData = res.returnObj.list
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },
    handleCurrentChange (val) {
      this.page.currentPage = val
      this.getList()
    },
    handleSizeChange (val) {
      this.page.currentPage = 1;
      this.page.pageSize = val
      this.getList()
    },
  }
}
</script>
<style lang="scss">
@import "../style/inspectionPlan.scss";
.info-value{
  width: 150px;
  display: inline-block;
  vertical-align: top
}
</style>
